import AppConfig, { AppMode, environments, isProductionHost, MODE_STORAGE_KEY } from 'app-config';
import { session } from './session';
import { AuthError } from './errors';

export async function switchEnvironment(mode: AppMode) {
  if (mode === AppConfig.mode) return;
  if (!isProductionHost()) {
    throw new AuthError('Environment switching is only available on the production dashboard.');
  }
  const target = environments[mode];
  if (!target?.ApiBaseUrl || !target.AuthMSBaseUrl) {
    throw new AuthError('The selected environment is not configured.');
  }
  if (new URL(target.AuthMSBaseUrl).hostname === new URL(AppConfig.AuthMSBaseUrl).hostname) {
    throw new AuthError('Live and sandbox must use different authentication hosts.');
  }
  await session.exclusive(async () => {
    // Persist the selection for every tab; open tabs stay pinned until they reload.
    // Environment-scoped sessions stay intact. Discard this tab's login flow.
    localStorage.setItem(MODE_STORAGE_KEY, mode);
    session.abandonChallenge();
    session.dispose();
    window.location.assign('/auth/login');
  });
}
